export default __webpack_public_path__ + "static/media/032-car.764db569.svg";